import { render } from "./StudentEditTable.vue?vue&type=template&id=155f3ac2&scoped=true&ts=true"
import script from "./StudentEditTable.vue?vue&type=script&lang=ts"
export * from "./StudentEditTable.vue?vue&type=script&lang=ts"

import "./StudentEditTable.vue?vue&type=style&index=0&id=155f3ac2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155f3ac2"]])

export default __exports__